import styled, { css, Interpolation } from 'styled-components'

export interface TiptapWrapperUiProps {
  styles?: Interpolation<object>
}

export const TiptapWrapperUi = styled.div<TiptapWrapperUiProps>`
  .tippy-box {
    min-width: 258px;
  }

  ${p =>
    !p.theme.isEditorMobileMode &&
    css`
      .tippy-box {
        max-width: none !important;
      }
    `}

    ${p =>
      p.styles &&
      css`
    ${p.styles}
  `}
`
